import React from 'react';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from '../../storeSearch.module.css';

var LocationInput = function LocationInput(props) {
  var value = props.value,
      onChange = props.onChange,
      formApi = props.formApi;
  var classes = useStyle(defaultClasses, props.classes);

  var handleOnChange = function handleOnChange(e) {
    onChange(e);
    formApi.setValue('address', value);
  };

  return React.createElement(React.Fragment, null, React.createElement("label", {
    htmlFor: "address",
    className: "sr-only"
  }, "Search by Zipcode/Postal Code, City or State/Province"), React.createElement("input", {
    type: "text",
    name: "address",
    id: "address",
    value: value,
    onChange: handleOnChange
  }), React.createElement("span", {
    className: "".concat(classes.placeholder, " ").concat(value && classes.valid)
  }, 'Search by Zipcode/Postal Code, City or State/Province'));
};

export default LocationInput;